<template>
  <Loading v-if="loading" />
  <Modal @close="closeModal">
    <div class="changePassword">
      <div class="changePassword-header">
        <span class="title">{{ $t('changePassword') }}</span>
        <img src="@/assets/icons/Close.svg" alt="" @click="closeModal" />
      </div>
      <div class="changePassword-body">
        <p class="text">
          {{ $t('infoChangePassword') }}
        </p>
        <FormKit
          id="changePassword-form"
          v-model="formData"
          type="form"
          :actions="false"
          :config="validationRules"
          @submit="submitHandler"
        >
          <div class="password-field">
            <PasswordInput
              name="password"
              class="changePassword-passwordInput"
              model-value="password"
              :label="$t('password')"
              validation="required|length:8"
              :validation-messages="{
                required: $t('validation.required'),
                length: $t('validation.lengthLong')
              }"
            />
            <PasswordInput
              name="password_confirm"
              class="changePassword-passwordInput"
              model-value="password_confirm"
              :label="$t('confirmPassword')"
              validation="required|confirm"
              :validation-messages="{
                required: $t('validation.required'),
                confirm: $t('validation.confirm')
              }"
            />
          </div>
        </FormKit>
      </div>
      <div class="buttons">
        <Button variant="filled" :title="$t('save')" @click="submitForm" />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="closeModal"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';
import { ChangePasswordData } from '@/store/modules/account/types';

@Options({
  name: 'ChangePassword',
  props: ['showModal'],
  emits: ['closeModal'],
  components: {
    Loading
  },
  data() {
    return {
      formData: {
        password: '',
        password_confirm: ''
      },
      validationRules: {},
      loading: false
    };
  },
  computed: {
    ...mapState('users', ['user'])
  },
  methods: {
    ...mapActions('users', ['changePasswordUserId']),
    async submitHandler(data: ChangePasswordData) {
      const payload = {
        ...data,
        newPassword: this.formData.password,
        repeatNewPassword: this.formData.password_confirm
      };
      delete payload.password;
      delete payload.password_confirm;

      const { id } = this.$route.params;
      if (id) {
        this.loading = true;
        await this.changePasswordUserId({
          data: payload,
          userId: id
        });

        this.$emit('closeModal');
        this.loading = false;
      }
    },
    submitForm() {
      this.$formkit.submit('changePassword-form');
    },
    closeModal() {
      this.$emit('closeModal');
      this.$formkit.reset('changePassword-form');
    }
  }
})
export default class ChangePassword extends Vue {}
</script>

<style lang="scss">
.changePassword {
  width: 412px;
  height: max-content;
  padding: 24px;
  .changePassword-header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: 14px;
    }
    img {
      cursor: pointer;
    }
  }
  .changePassword-body {
    padding-top: 16px;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: 21px;
      .span-box {
        color: $label;
        font-weight: 600;
        font-family: 'Ubuntu-Medium';
      }
    }
    .password-field {
      width: 412px;
      margin-top: 32px;
      margin-bottom: 0;
      .changePassword-passwordInput {
        height: 100%;
        padding: 0;
        .formkit-outer {
          .formkit-wrapper {
            max-width: 412px;
            .formkit-inner {
              max-width: 412px;
            }
          }
        }
      }
    }
  }
}
</style>
